import React from "react";
import { Box, Collapse, Typography } from "@mui/material";
import InviteCallout from "./InviteCallout";
import { inviteTextSx } from "./inviteTypography";

export interface InviteErrorSlotProps {
  facebookError?: string | null;
  youtubeError?: string | null;
  tiktokError?: string | null;
  spotifyError?: string | null;
  disconnectError?: string | null;
}

export const InviteErrorSlot: React.FC<InviteErrorSlotProps> = ({
  facebookError,
  youtubeError,
  tiktokError,
  spotifyError,
  disconnectError,
}) => {
  const hasError = !!(
    facebookError ||
    youtubeError ||
    tiktokError ||
    spotifyError ||
    disconnectError
  );

  if (!hasError) return null;

  return (
    <Box sx={{ width: "100%", overflow: "hidden" }}>
      <Collapse in={!!facebookError}>
        {facebookError && (
          <InviteCallout variant="error" sx={{ mb: 1 }}>
            <Typography variant="body2" sx={inviteTextSx}>
              {facebookError}
            </Typography>
          </InviteCallout>
        )}
      </Collapse>
      <Collapse in={!!youtubeError}>
        {youtubeError && (
          <InviteCallout variant="error" sx={{ mb: 1 }}>
            <Typography variant="body2" sx={inviteTextSx}>
              {youtubeError}
            </Typography>
          </InviteCallout>
        )}
      </Collapse>
      <Collapse in={!!tiktokError}>
        {tiktokError && (
          <InviteCallout variant="error" sx={{ mb: 1 }}>
            <Typography variant="body2" sx={inviteTextSx}>
              {tiktokError}
            </Typography>
          </InviteCallout>
        )}
      </Collapse>
      <Collapse in={!!spotifyError}>
        {spotifyError && (
          <InviteCallout variant="error" sx={{ mb: 1 }}>
            <Typography variant="body2" sx={inviteTextSx}>
              {spotifyError}
            </Typography>
          </InviteCallout>
        )}
      </Collapse>
      <Collapse in={!!disconnectError}>
        {disconnectError && (
          <InviteCallout variant="error" sx={{ mb: 1 }}>
            <Typography variant="body2" sx={inviteTextSx}>
              {disconnectError}
            </Typography>
          </InviteCallout>
        )}
      </Collapse>
    </Box>
  );
};

export default InviteErrorSlot;
